<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{ `${$t("lockerDelivery.deliveryId")}: ${lockerDelivery.deliveryId}` }}
      </p>
    </header>

    <section class="modal-card-body">
      <locker-delivery-status
        :status="lockerDelivery.status"
        :observations="lockerDelivery.observations"
      />

      <locker-delivery-steps :status="lockerDelivery.status" />

      <locker-delivery-steps-dates
        :statusHistory="lockerDelivery.statusHistory"
      />

      <hr />

      <div class="columns">
        <locker-delivery-person-details
          v-if="lockerDelivery.courier"
          personType="courier"
          :personInfo="lockerDelivery.courier"
          :deliveryId="lockerDelivery._id"
        />

        <locker-delivery-person-details
          personType="client"
          :personInfo="lockerDelivery.client"
          :deliveryId="lockerDelivery._id"
        />

        <locker-details
          :locker="lockerDelivery.locker"
          :deliveryId="lockerDelivery._id"
          @get-locker-deliveries="getLockerDeliveries"
          @edit-info="isEditInfoModalActive = true"
        />
      </div>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.close") }}
      </button>
    </footer>

    <b-modal :active.sync="isEditInfoModalActive">
      <edit-info-modal
        :lockerDelivery="lockerDelivery"
        @info-updated="updateInfo"
      />
    </b-modal>
  </div>
</template>

<script>
import lockerDeliveryStatus from "./LockerDeliveryStatus";
import lockerDeliverySteps from "./LockerDeliverySteps";
import lockerDeliveryStepsDates from "./LockerDeliveryStepsDates";
import lockerDeliveryPersonDetails from "./LockerDeliveryPersonDetails";
import lockerDetails from "./LockerDetails";
import editInfoModal from "./EditInfoModal";

export default {
  props: ["lockerDelivery"],

  data() {
    return {
      isEditInfoModalActive: false
    };
  },

  components: {
    lockerDeliveryStatus,
    lockerDeliverySteps,
    lockerDeliveryStepsDates,
    lockerDeliveryPersonDetails,
    lockerDetails,
    editInfoModal
  },

  methods: {
    getLockerDeliveries() {
      this.$emit("get-locker-deliveries");
    },

    updateInfo(data) {
      this.lockerDelivery.client.personalInfo.name = data.clientName;
      this.lockerDelivery.client.personalInfo.personalId =
        data.clientPersonalId;
      this.lockerDelivery.observations = data.observations;

      if (this.lockerDelivery.courier) {
        this.lockerDelivery.courier.personalInfo.name = data.courierName;
        this.lockerDelivery.courier.personalInfo.personalId =
          data.courierPersonalId;
      }
    }
  }
};
</script>

<style scoped>
hr {
  margin-top: 0;
  margin-bottom: 1rem;
}
</style>
